import SearchView from 'scoreboard/components/search-view'

import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import PrincipalList from '../principal-list'
import UserListFilter from './user-list-filter'
import Sifter from 'scoreboard/components/scoreboard-sifter'
import Tooltip from 'scoreboard/components/tooltip'
import constants from 'scoreboard/components/constants'
const ALL_FIELDS = ''
const fields = ['firstName', 'lastName', 'middleName', 'label', 'id', 'username', 'email']
import User from './user'

const UserList = PrincipalList.extend({

	headingKey: 'common.user.users',
	searchMessageKey: 'admin.user.search',
	showFilter: true,
	fieldName: ALL_FIELDS,

	events: _.extend({}, PrincipalList.prototype.events, {
		'click .filter': '_filter'
	}),

	render: function() {
		PrincipalList.prototype.render.apply(this, arguments)
		this.searchView = new SearchView({
			url: _.result(User.prototype, 'urlRoot')
		})
		_.extend(this.searchView, {
			draw: this.draw.bind(this),
			createLoadingDots: this.createLoadingDots.bind(this),
			loadingDotsContainer: () => this.$('.admin-results-message')
		})

		return this
	},

	getSifterFields: function() {
		return _.isEmpty(this.fieldName) ? fields : [this.fieldName]
	},

	_getNumPrincipals: function() {
		return this.xhr.getResponseHeader(constants.NUM_USERS_HEADER) ??
			_.size(this.filteredPrincipals)
	},

	find: function (text) {
		var textEntered = _.isString(this.finder.text())
		this.hasUserInteracted = this.hasUserInteracted || textEntered

		// once the search is done, this.draw will be called
		this.searchView.search(text)
	},

	draw: function(users, options, text, xhr) {
		this.setXhr(xhr)
		this.filteredPrincipals = _.keyBy(users, 'id')
		this.results = {
			items: users,
			total: this._getNumPrincipals(),
			query: text
		}
		this.renderResults()
	},

	_filter: function(e) {
		const target = $(e.currentTarget)

		this.listFilterView = new UserListFilter({
			allFields: ALL_FIELDS,
			fields,
			fieldName: this.fieldName,
			sortDirection: this.sortDirection
		})

		this.filterTooltip = new Tooltip({
			attachTo: target,
			content: this.listFilterView,
			placement: 'below',
			arrow: 'right',
			extraClass: 'has-bootslide-menu filter-tooltip'
		}).render()


		this.listenTo(this.listFilterView, 'field', fieldName => {
			this.fieldName = fieldName
			if (this.principals) {
				this.filteredPrincipals = this.preFilter(this.principals)
				this.sifter = new Sifter(this.filteredPrincipals)
				this.find() // This reloads the result list
			}
		})

		this.listenTo(this.listFilterView, 'sort', sortDirection => {
			this.sortDirection = sortDirection
			this.find() // This reloads the result list
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.listFilterView, this.filterTooltip,
			this.searchView], 'remove')
	}

})

export default UserList

UserList.__filename__ = 'admin/principals/users/user-list.js'
